function createAction(name) {
  return `@@form/${name}`;
}
export const TRACK_USAGE = createAction('TRACK_USAGE');
export function trackUsage(event, options) {
  return {
    type: TRACK_USAGE,
    event,
    options
  };
}
export default trackUsage;